import {
  Controller,
} from '@hotwired/stimulus';

export default class extends Controller {
  interval = null

  connect() {
    this.listener = () => { this.startCounter() };
    document.addEventListener('click', this.listener);
    this.startCounter();
  }

  disconnect() {
    document.removeEventListener('click', this.listener);
    if (this.interval) clearInterval(this.interval);
  }

  startCounter() {
    this.timeout = 120;
    if (this.interval) clearInterval(this.interval);
    this.interval = setInterval(() => {
      this.timeout -= 1;
      if (this.timeout < 0) {
        clearInterval(this.interval);
        this.interval = null;
        this.element.click();
      }
    }, 1000);
  }
}
